
import HttpClient from '../HttpService';

function findOrCreate(data) {
    return HttpClient.post('/pdis/find-or-create', data);
}

function update(id, data) {
    return HttpClient.put(`/pdis/${id}`, data);
}

export default {
	update,
    findOrCreate
}